import e from "@dialpad/dialtone-tokens/layered/themes/tokens-poppy-field-colors.css?inline";
//#region themes/poppy-field.js
var t = {
	brand: {
		css: e,
		name: "poppy-field"
	},
	material: { name: "sandstone" }
};
//#endregion
export { t as default };
